import React from "react";

type TabsContainerProps = {
  children: string | React.ReactNode;
};

export const TabsContainer = ({ children }: TabsContainerProps) => {
  return <div>{children}</div>;
};
